import { Block, SimpleTextArea } from '@aloft/toolkit-sui';

import { SiteSizeVsCostPerSFChartUnwrapped } from '../../../components/SiteValueCharts/SiteSizeVsCostPerSFChart.tsx';
import { SiteSizeVsSiteValueChartUnwrapped } from '../../../components/SiteValueCharts/SiteSizeVsSiteValueChart.tsx';
import { setSiteValueCommentary } from '../../../redux/features/propertyDataSlice.ts';
import { selectSiteExtractionCommentaryTableDisplay } from '../../../redux/features/selectors/commentarySelectors/selectSiteExtractionCommentary.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';
import { useTkv2SiteValueChartsParams } from '../../referenceView/utils/useTkv2SiteValueChartsParams.ts';
import { CommentaryChartContainer } from '../components/CommentaryChartContainer.tsx';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { CommentaryTable } from '../components/CommentaryTable.tsx';
import { getCommentarySectionText } from '../utils.ts';

export const SiteExtraction = () => {
  const siteExtraction = useAppSelector((state) =>
    selectSiteExtractionCommentaryTableDisplay(state),
  );
  const { siteSizeVsSiteValueChartData, siteSizeVsPriceChartData } = useTkv2SiteValueChartsParams();
  const dispatch = useAppDispatch();

  return (
    <CommentarySection {...getCommentarySectionText('site-extraction')}>
      <CommentaryTable data={siteExtraction.data} helperText={siteExtraction.helperText} />

      <CommentaryChartContainer title="Site Size vs Site Value">
        <SiteSizeVsSiteValueChartUnwrapped data={siteSizeVsSiteValueChartData} />
      </CommentaryChartContainer>

      <CommentaryChartContainer title="Site Size vs $/SF">
        <SiteSizeVsCostPerSFChartUnwrapped data={siteSizeVsPriceChartData} />
      </CommentaryChartContainer>
      <Block maxWidth="40rem">
        <SimpleTextArea
          value={siteExtraction.commentary}
          onChange={(e) => dispatch(setSiteValueCommentary(e.target.value))}
          size="lg"
          label="Commentary"
        />
      </Block>
    </CommentarySection>
  );
};
